export default "__VITE_ASSET__Drg3Mirh__"